import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { EventStore } from 'src/app/models';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class EventStoreService {
  private http = inject(HttpClient);

  private readonly eventStoreEndpoint = `${environment.apiOrigin}/Merchants/EventStores`;
  private eventStoreSignal = signal<EventStore[]>(null);

  isEventStore = false;
  readonly eventStores = this.eventStoreSignal.asReadonly();

  async load(merchantId: number) {
    return new Promise<void>((resolve) => {
      this.http.get<EventStore[]>(`${this.eventStoreEndpoint}/${merchantId}/Active`).subscribe((eventStores) => {
        this.isEventStore = true;
        this.eventStoreSignal.set(eventStores);

        resolve();
      });
    });
  }
}
